import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { X, ArrowRight } from 'lucide-react';
import { marqueeItems } from '../mock';

const Marquee = ({ onOpenDemo }) => {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;

  const items = [...marqueeItems, ...marqueeItems];

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-[#0F172A]/95 dark backdrop-blur-xl border-t border-[#1E293B]">
      <div className="flex items-center h-11">
        <div className="marquee-container flex-1 overflow-hidden relative">
          <div className="marquee-track">
            {items.map((item, i) => (
              <div key={i} className="flex items-center gap-3 px-6 whitespace-nowrap">
                <span className="w-1 h-1 rounded-full bg-[#6366F1]" />
                <span className="text-[11px] text-ink-2">{item}</span>
              </div>
            ))}
          </div>
          <div className="pointer-events-none absolute left-0 top-0 h-full w-16 bg-gradient-to-r from-[#0F172A] to-transparent" />
          <div className="pointer-events-none absolute right-0 top-0 h-full w-16 bg-gradient-to-l from-[#0F172A] to-transparent" />
        </div>

        <Link
          to="/contact"
          className="text-[11px] font-medium text-ink hover:text-ink-2 transition-colors inline-flex items-center gap-1.5 px-4 border-l border-[var(--line-2)] h-full"
        >
          Contact us <ArrowRight className="w-3 h-3" />
        </Link>
        <button
          onClick={() => setVisible(false)}
          className="p-3 text-ink-3 hover:text-ink transition-colors border-l border-[var(--line-2)] h-full"
          aria-label="Close"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
};

export default Marquee;
